import { useEffect, useRef, useState } from "react";
import DashboardFooter from "../Components/Footer";
import DashboardHeader from "../Components/Header";
import DashboardSidebarMenu from "../Components/SidebarMenu";
import WebsitePlanStatusMsg from "../Components/WebsitePlanStatusMsg";
import MainPageTemplate from "./MainPageTemplate";
import useWindowSize from "../Helpers/useWindowSize";
import EUServerMigrationPopup from "../Components/EUServerMigrationPopup";
import { useSelector } from "react-redux";
import { StoreProptypes } from "../PropTypes/StoreProptypes";
import { getUserDetailsService } from "../Services/UserAction/LoginActionService";
import { useDispatch } from "react-redux";
import { getUserDetailsApi } from "../Api/UserAction/LoginActionApi";
import { SET_CURRENT_WEBSITE, SET_GOOGLE_VOICES, SET_MESSAGE, SET_REVIEW_URL, UPDATE_USER } from "../Actions/Types";
import { DomainDetailsApi } from "../Api/DomainApi/DomainDetailsApi";
import isGreater from "../Helpers/DateCompare";
import { ActiveNewsApi } from "../Api/ActiveNewsApi";
import { closeNewsService } from "../Services/NewsService";
import { useTranslation } from "react-i18next";
import useG2Review from "../Pages/DashboardPage/useG2Review";
import G2ReviewModal from "../Pages/DashboardPage/G2ReviewModal";
import detectIncognito from "detectincognitojs";

interface PropTypes {
    children: any
}

const euServerStartDate = `${process.env.REACT_APP_EU_START_DATE}`;

// template to display dashboard page
const DashboardPagesTemplate = (prop: PropTypes) => {
    // Set Props
    const { children } = prop;
    const { t } = useTranslation();

    // Function
    const closeButtonRef = useRef<HTMLButtonElement | null>(null);
    const { windowSize } = useWindowSize();

    // State
    const [firstLoadTime, setFirstTimeLoad] = useState(true);
    const [mobileMenu, setMobileMenu] = useState(true);
    const [showAnnouncement, setShowAnnouncement] = useState<boolean>(false);
    const { getReviewUrl } = useG2Review();
    const [open, setOpen] = useState(false);
    
    const [description, setDescription] = useState<string>('')
    const [newsId, setNewsId] = useState<number | null>(null)

    const dispatch = useDispatch();

    // Redux Data
    const { currentWebsite, websiteList, accessToken, user, reviewUrl } = useSelector((store: StoreProptypes) => store);

    // Navigation Menu class
    const bodyClassList = ['ada_dashboard-sidebar-navigation-open', 'overflow-hidden']

    // function to handle mobile menu toggle
    const handelMobileMenu = () => {
        // check if mobile menu is opened
        if (document.body.classList.contains('ada_dashboard-sidebar-navigation-open')) {
            document.body.classList.remove(...bodyClassList);
            setMobileMenu(false);
        } else {
            document.body.classList.add(...bodyClassList);
            setMobileMenu(true);
        }
    }

    // function to close mobile menu
    const handelCloseMobileMenu = () => {
        document.body.classList.remove(...bodyClassList);
        setMobileMenu(false);
    }

    useEffect(() => {
        // check if window size is less than 1400px
        if (windowSize <= 1399 && !mobileMenu && closeButtonRef && closeButtonRef.current) {
            // check if its being call first time
            if (!firstLoadTime) {
                closeButtonRef.current.focus();
            } else {
                setFirstTimeLoad(false);
            }
        }
    }, [mobileMenu]);

    useEffect(() => {
        if (currentWebsite && currentWebsite.id && !currentWebsite?.hasOwnProperty('is_eu_script_show') && accessToken) {
            DomainDetailsApi(accessToken, currentWebsite.id)
                .then((res) => {
                    if (res.Data.length > 0) {
                        dispatch({
                           type: SET_CURRENT_WEBSITE,
                           payload: {...res.Data[0], is_eu_script_show_first:res.Data[0].is_eu_script_show_first, is_eu_script_show:res.Data[0].is_eu_script_show, no_required_eu: res.Data[0].no_required_eu},
                        });
                    }
                })
                .catch((err) => {
                    console.log('err: ', err);
                })
                .finally(() => {});
        }
    }, [currentWebsite, accessToken]);

    useEffect(() => {
        if (currentWebsite && currentWebsite.id && !currentWebsite?.hasOwnProperty('googleVoices') && accessToken) {
            dispatch({
                type: SET_GOOGLE_VOICES,
                payload: null
            });
        }
    }, [currentWebsite, accessToken]);

    useEffect(() => {
        console.log('user: ', user);
        console.log('currentWebsite: ', currentWebsite);
        if (accessToken && currentWebsite && user) {
            let package_id = 0
            let platform = currentWebsite.platform
            if (currentWebsite && (currentWebsite.current_package_only?.length > 0 )) {
                package_id = currentWebsite.current_package_only[0].package_id
            } else if(currentWebsite && (currentWebsite.expired_package_detail?.length > 0 )) {
                package_id = currentWebsite.expired_package_detail[0].package_id
            }else if(currentWebsite && (currentWebsite.canceled_package_only?.length > 0 )) {
                package_id = currentWebsite.canceled_package_only[0].package_id
            }
      
            ActiveNewsApi(accessToken, platform, package_id ?? 0, user.country !== null ? user.country.toString() : null)
                .then((res) => {
                    if (res.data.length > 0) {
                        const style = document.createElement("style");
                        if (res.data[0].style !== '' && res.data[0].style !== null) {
                            style.textContent = res.data[0].style;
                        } else {
                            style.textContent = `.announcement-bar-section{font-size:18px;line-height:normal;color:#fff;background:#f9bf3b;background:linear-gradient(-90deg, #420083 0%, #000229 100%);padding:10px 15px;z-index:15;position:relative;}
                                @media only screen and (min-width: 1300px){
                                .announcement-bar-section{font-size:20px;}
                                }
                                .announcement-bar-section .inner-wrapper{display:flex;flex-wrap:wrap;align-items:center;justify-content:center;flex-direction:column;}
                                @media only screen and (min-width: 1200px){
                                .announcement-bar-section .inner-wrapper{flex-direction:row;}
                                }
                                .announcement-bar-section p{margin-bottom:0;line-height:1.3;}
                                .announcement-bar-section .text{font-weight:700;text-align:center;}
                                .announcement-bar-section .discount-text{display:flex;flex-wrap:wrap;align-items:center;justify-content:center;font-weight:700;margin-top:10px;}
                                @media only screen and (min-width: 1200px){
                                .announcement-bar-section .discount-text{border-left:1px solid rgba(255,255,255,.3);margin-top:0;padding-left:20px;margin-left:20px;}
                                }
                                .announcement-bar-section .discount-text>a{margin-left:10px;color:#fff;text-decoration:underline;}
                                .announcement-bar-section .coupon-code-wrapper{display:flex;text-decoration:none;font-size:16px;color:#fff;background:rgba(255,255,255,.18);border-radius:5px;margin:5px 12px;position:relative;transition:all .2s ease;box-shadow:0 5px 5px rgba(208,208,208,.15);}
                                @media only screen and (min-width: 1300px){
                                .announcement-bar-section .coupon-code-wrapper{font-size:18px;}
                                }
                                .announcement-bar-section .coupon-code-wrapper .coupon-code-text{font-weight:bold;padding:6px 14px;border:1px solid #fff;border-radius:5px 0 0 5px;margin-right:-1px;}
                                .announcement-bar-section .coupon-code-wrapper .coupon-code{background-color:#fff;color:#000;border:none;padding:6px 10px;border:1px solid #fff;border-radius:0 5px 5px 0;transition:all .2s ease;}
                                .announcement-bar-section .coupon-code-wrapper .coupon-code:hover,.announcement-bar-section .coupon-code-wrapper .coupon-code:focus{background:#e7e7e7;border-color:#e7e7e7;}
                                .announcement-bar-section .coupon-code-wrapper .coupon-code .copy-text{display:block;margin-bottom:2px;font-size:16px;font-weight:bold;}
                                .announcement-bar-section .coupon-code-wrapper .copy-msg{position:absolute;top:calc(100% + 12px);left:0;font-size:15px;background:#000;color:#fff;font-weight:500;min-width:160px;z-index:99;width:65%;border-radius:5px;padding:10px 14px;text-align:center;display:none;}
                                .announcement-bar-section .coupon-code-wrapper .copy-msg::before{content:"";width:0;height:0;border-left:10px solid rgba(0,0,0,0);border-right:10px solid rgba(0,0,0,0);border-bottom:10px solid #000;position:absolute;top:-10px;left:50%;transform:translateX(-50%);}
                                .announcement-bar-section .cc-tnc-link{color:#000;font-size:.9rem;font-weight:normal;line-height:1;display:inline-block;text-decoration:underline;margin-top:6px;}
                                }`;
                        }
                        document.head.appendChild(style);
                        setDescription(res.data[0].description);
                        setNewsId(res.data[0].id);

                        (window as any).copyContent = function () {
                            const code = document.querySelector<HTMLElement>(`.${res.data[0].class}`)?.innerText;
                            if (!code) return;

                            navigator.clipboard.writeText(code);
                            dispatch({
                                type: SET_MESSAGE,
                                payload: {
                                    "toast_message": t('Copied'),
                                    "toast_type": "success"
                                }
                            });
                        };
                    }
                })
                .catch((err) => {
                    console.log('err: ', err);
                })
                .finally(() => {});
        }
    }, [accessToken, currentWebsite, user]);

    useEffect(() => {
        if (description) {
            setShowAnnouncement(true);
        }
    }, [description]);

    useEffect(() => {
        const fetchReviewUrl = async () => {
            const isRestrictedEmail = (email:string) => {
                return /test|demo|skynet/i.test(email);
            };
            const reviewDismissed = localStorage.getItem("g2_review_done");
            const isPrivateMode = await detectIncognito().then((result) => {
                return result.isPrivate;
            });
            if (!reviewDismissed && user?.email && currentWebsite && currentWebsite.is_verified && currentWebsite.is_verified === 1 && user.department !== 1 && !isRestrictedEmail(user?.email) && !isPrivateMode) {
                dispatch({
                    type: SET_REVIEW_URL,
                    payload: null,
                });
                const isprocessed = await getReviewUrl();
                if (isprocessed) {
                    setOpen(true);
                }
            }
        };

        fetchReviewUrl();
    }, [user, currentWebsite]);

    const handleCancel = () => {
        if (newsId && accessToken) {
            closeNewsService(
                accessToken,
                newsId,
                () => setShowAnnouncement(false)
            );
        }
    };

    return (
        <>
            {showAnnouncement && description && (
                <div className="announcement-wrapper">
                    <button
                        className="announcement-close"
                        onMouseDown={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            handleCancel();
                        }}
                        aria-label="Close announcement"
                    >
                        ✕
                    </button>
                    <div
                        dangerouslySetInnerHTML={{ __html: description }}
                        className="announcement-content"
                    />
                </div>
            )}
            <MainPageTemplate>
                <DashboardSidebarMenu mobileMenu={mobileMenu} handelMobileMenu={handelMobileMenu} handelCloseMobileMenu={handelCloseMobileMenu} />
                <div className="aioa_dashboard-content-wrapper">
                    <DashboardHeader handelMobileMenu={handelMobileMenu} />
                    <main id="main">
                        <WebsitePlanStatusMsg />
                        <div className="aioa_dashboard-page-content aioa_dashboard-pages">
                            {children}
                        </div>
                    </main>
                    <DashboardFooter />
                     {(currentWebsite) && ((websiteList.length === 1) || (currentWebsite?.current_package_only && currentWebsite.current_package_only.length > 0 && isGreater(currentWebsite.current_package_only[0].start_date, euServerStartDate))) ? (
                        <>
                            <EUServerMigrationPopup
                                key={currentWebsite.id}
                                isShow={currentWebsite?.is_eu_script_show_first || 0}
                                isFirstTimeLoad={true}
                                isFromDashboard={false}
                                widgetAPIKey={(currentWebsite.current_package_only && currentWebsite.current_package_only.length > 0) ? currentWebsite.current_package_only[0].api_key : null}
                                widgetPosition={currentWebsite.widget_position !== null ? currentWebsite.widget_position : `bottom_right`}
                                widgetColor={currentWebsite.widget_color_code !== null ? currentWebsite.widget_color_code : `#420083`}
                            />
                        </>
                        ):(<>
                        </>)}
                </div>
                 {open && (
                    <G2ReviewModal
                        reviewUrl={reviewUrl}
                        onClose={() => {
                            localStorage.setItem("g2_review_done", "true");
                            setOpen(false);
                        }}
                    />
                )}
            </MainPageTemplate>
        </>
    )
}

export default DashboardPagesTemplate;